import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import Banner from '../../components/Banner'
import Pagination from '../../components/Pagination';
import Items from './items/Items';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setCategory, selectItems, setPage, setItemPerPage, getFilteredItems } from '../../slice/itemSlice';
import Filter from './Filter';
import Icons from '../../components/icons/Icons';
import Newsletter from '../../components/newsletter/Newsletter';
import vintageComputers from '../../assets/vintage-computers.webp'


const ProductsByCategoryPage = () => {
  const { category } = useParams();
  const dispatch = useDispatch();
  const items = useSelector(selectItems);

  useEffect(() => {
    dispatch(getFilteredItems())
  },[category, dispatch])

  useEffect(() => {
    dispatch(setCategory(category))
    dispatch(setPage(1))
    dispatch(setItemPerPage(12))
  }, [category, dispatch, items])

  return (<div className='page-wrapper w-100 bg-light' >
    {/* <Banner /> */}
    <Banner img={vintageComputers}>
      <h1 className='text-capitalize display-1'>{category}<span className='text-info fw-bold'>.</span></h1>

    </Banner>
    <Container >
      <Pagination items={items}/>
      <Filter />
      <Items />
      <Pagination  items={items}/>
      <Icons />
      <Newsletter />
    </Container>
  </div>)
}

export default ProductsByCategoryPage